// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".font[data-v-3d6dd581]{color:#000;margin:0 5px 10px}", ""]);
// Exports
module.exports = exports;
